// Never import any server-only code here, this is also used on the client side...

// Dutch version of the translation file
export const translations = {
  emails: {
    footer: {
      kindRegards: 'Met vriendelijke groeten,',
      questionsOrProblems: 'Vragen of problemen?',
      contactUs: 'Contacteer ons',
    },
    transportOrder: {
      confirm: 'Bevestig',
      refuse: 'Weiger',
    },
    forgotPassword: {
      resetLink: 'Stel nieuw wachtwoord in',
    },
    userInvite: {
      view: 'Bekijk uitnodiging',
    },
    attachments: {
      quotation: 'Offerte {{reference}}',
    },
    customerComplaintAlert: {
      order: 'Bekijk order',
    },
  },
  trailerTypes: {
    BoxTrailer: 'Box Trailer',
    FlatBed: 'Flat bed',
    Mega: 'Mega oplegger',
    Refrigerated: 'Koelwagen',
    RoadTrain: 'Road Train',
    Tautliner: 'Tautliner',
    Joloda: 'Tautliner / Joloda',
    TautlinerCoil: 'Tautliner / Coil',
  },
  loadingMethods: {
    Back: 'Achterkant',
    Side: 'Zijkant',
    Top: 'Via het dak',
  },
  truckDocumentType: {
    Insurance: 'Verzekering',
    Examination: 'Keuring',
  },
  orderDocumentType: {
    cmr: 'CMR',
    deliveryNote: 'Leveringsbon',
    weighSlip: 'Weegbon',
    palletNote: 'Palletbon',
    annexII: 'Annex II',
    t1Document: 'T1-document',
    annexVII: 'Annex VII',
    saleInvoice: 'Verkoopfactuur',
    transportOrder: 'Transportopdracht',
    orderConfirmation: 'Orderbevestiging',
    sustainabilityReport: 'Duurzaamheidsrapport',
    customerAttachment: 'Bijlage klant',
    planning: 'Planning',
    other: 'Andere',
  },
  documentRejection: {
    subject: 'Document afgekeurd voor dossier {{orderNumber}}',
    intro:
      'Het {{documentType}} document dat we ontvingen voor dossier {{orderNumber}} kunnen we helaas niet goedkeuren. Hieronder lichten we toe waarom:',
    outro: 'Gelieve een nieuw document aan te leveren via de gebruikelijke weg of via het carrier-portaal. Bedankt!',
    MissingSignature: 'De handtekening van de ontvanger ontbreekt op de CMR.',
    WrongCustomer: 'De klant op het document komt niet overeen met de klant van dit dossier.',
    WrongOrgOnDocument: 'De afzender/expediteur op het document komt niet overeen met onze organisatie.',
    NoOrderReference:
      'We konden geen geldige dossier- of factuurreferentie vinden om dit document aan een dossier te koppelen.',
    WrongDocumentType: 'Het type document komt niet overeen met wat we voor dit dossier verwachten.',
    LowQuality:
      'De scan/foto is van te lage kwaliteit om de inhoud betrouwbaar te kunnen valideren. Gelieve een hogere kwaliteit aan te leveren.',
  },
  documents: {
    note: {
      extraInformation: 'Extra informatie',
    },
    letter: {
      letter: 'Brief',
    },
    paymentReminder: {
      invoiceNumber: 'Factuur nummer',
      invoiceDate: 'Factuur datum',
      dueDate: 'Vervaldatum',
      amount: 'Bedrag',
      expiredAmount: 'Vervallen bedrag',
      currency: 'Munteenheid',
      totalOutstanding: 'Totaal openstaand',
      salutation: 'Geachte heer, mevrouw,',
      subject: {
        first: 'Betreft: betalingsherinnering — {{reference}}',
        second: 'Betreft: tweede betalingsherinnering — {{reference}}',
        third: 'Betreft: derde betalingsherinnering — {{reference}}',
        final: 'Betreft: ingebrekestelling — {{reference}}',
      },
      intro: {
        first:
          'Uit onze administratie blijkt dat onderstaande facturen nog niet betaald zijn. Als uw betaling deze brief gekruist heeft, mag u deze als niet verzonden beschouwen.',
        second: 'Ondanks onze eerdere herinnering hebben wij nog geen betaling ontvangen voor onderstaande facturen:',
        third: 'Ondanks herhaalde herinneringen staan onderstaande facturen nog steeds open:',
        final:
          'Ondanks eerdere betalingsherinneringen hebben wij tot op heden geen betaling ontvangen voor onderstaande facturen:',
      },
      request:
        'Wij verzoeken u het openstaande bedrag van {{amount}} binnen {{days}} kalenderdagen na ontvangst van deze brief over te schrijven op onderstaande rekening, met vermelding van de referentie:',
      acknowledgement:
        'Indien u niet betaalt en hiervoor geen reden opgeeft, wordt dit beschouwd als een erkenning van de schuld.',
      escalation: {
        first: 'Ontvangen wij uw betaling niet binnen deze termijn, dan sturen wij u een volgende herinnering.',
        second:
          'Ontvangen wij uw betaling niet binnen deze termijn, dan zijn wij genoodzaakt dit dossier te escaleren.',
        third: 'Blijft betaling binnen deze termijn uit, dan gaat dit dossier over naar onze invorderingsprocedure.',
        final:
          'Blijft betaling binnen deze termijn uit, dan geven wij dit dossier zonder verdere verwittiging in handen van onze raadsman, met opdracht een gerechtelijke procedure tegen u op te starten. De kosten hiervan zijn volledig te uwen laste.',
      },
      closing: {
        first: 'Wij vertrouwen erop dat u het openstaande bedrag binnen de gevraagde termijn voldoet.',
        second: 'Wij vertrouwen erop dat u het openstaande bedrag binnen de gevraagde termijn voldoet.',
        third: 'Wij vertrouwen erop dat u het openstaande bedrag binnen de gevraagde termijn voldoet.',
        final:
          'Wij vertrouwen erop dat dit niet nodig zal zijn en dat u het openstaande bedrag binnen de gevraagde termijn voldoet.',
      },
      sincerely: 'Met vriendelijke groeten,',
      signature: 'Boekhouding {{company}}',
      account: 'Rekening {{company}}',
      accounts: 'Rekeningen {{company}}',
      reference: 'Mededeling',
      amountDue: 'Te betalen bedrag',
      bic: 'BIC',
      heldBy: 'op naam van {{company}}',
      date: 'Datum',
      ourReference: 'Onze referentie',
      customerNumber: 'Klantnummer',
      yourVatNumber: 'Uw btw-nummer',
      contact: 'Contact',
      phone: 'Telefoon',
    },
    transportOrder: {
      trailerTypes: 'Trailer Types',
      loadingMethod: 'Wijze van belading',
      transportOrder: 'Transport Opdracht',
      date: 'Datum',
      orderRef: 'Order Referentie',
      load: 'Laden',
      unload: 'Lossen',
      reference: 'Referentie',
      goods: 'Goederen',
      description: 'Omschrijving',
      palletCount: 'Aantal pallets',
      packageType: 'Pallettype',
      weight: 'Gewicht',
      LoadingMeter: 'Laadmeter',
      freightRate: 'Vrachttarief',
      price: 'Prijs',
      vat: 'BTW',
      questionsOrComments: 'Vragen of opmerkingen?',
      contactFileManager: 'Neem gerust contact op met uw dossierverantwoordelijke',
      anonymousCmr: 'ANONIEME CMR MOET AANGEMAAKT WORDEN VOOR DEZE ORDER.',
      phone: 'Tel.',
      email: 'E-mail',
    },
    planning: {
      planning: 'Planning',
      licensePlate: 'Nummerplaat',
      codeName: 'Codenaam',
    },
    kilometers: {
      full: 'Volle kilometers',
      empty: 'Lege kilometers',
      total: 'Totaal kilometers',
      planningTotal: 'Totaal van deze planning',
    },
    orderConfirmation: {
      orderConfirmation: 'Bestelbevestiging',
      dearCustomer: 'Beste klant,',
      herebyWeConfirmYourOrder: 'Bij deze bevestigen wij uw bestelling van onderstaand transport:',
      date: 'Datum',
      ourReference: 'Onze referentie',
      yourReference: 'Uw referentie',
      load: 'Laden',
      unload: 'Lossen',
      reference: 'Referentie',
      goods: 'Goederen',
      description: 'Omschrijving',
      packageType: 'Pallettype',
      palletCount: 'Pallets',
      weight: 'Gewicht',
      LoadingMeter: 'Laadmeter',
      freightRate: 'Vrachttarief',
      price: 'Prijs',
      vat: 'BTW',
      questionsOrComments: 'Vragen of opmerkingen?',
      contactFileManager: 'Neem gerust contact op met uw dossierverantwoordelijke',
      phone: 'Tel.',
      email: 'E-mail',
    },
    orderCancellation: {
      orderCancellation: 'Bestelanulatie',
      dearCustomer: 'Beste klant,',
      orderCancelledText: 'Uw bestelling van onderstaand transport is bij deze geannuleerd:',
      date: 'Datum',
      ourReference: 'Onze referentie',
      yourReference: 'Uw referentie',
      load: 'Laden',
      unload: 'Lossen',
      reference: 'Referentie',
      goods: 'Goederen',
      description: 'Omschrijving',
      packageType: 'Pallettype',
      palletCount: 'Pallets',
      weight: 'Gewicht',
      LoadingMeter: 'Laadmeter',
      freightRate: 'Vrachttarief',
      price: 'Prijs',
      vat: 'BTW',
      questionsOrComments: 'Vragen of opmerkingen?',
      contactFileManager: 'Neem gerust contact op met uw dossierverantwoordelijke',
      phone: 'Tel.',
      email: 'E-mail',
    },
    invoice: {
      invoice: 'Factuur',
      customerNumber: 'Klantnummer',
      invoiceNumber: 'Factuurnummer',
      invoiceDate: 'Factuurdatum',
      dueDate: 'Vervaldatum',
      load: 'Laden',
      unload: 'Lossen',
      ourReference: 'Onze referentie',
      yourReference: 'Uw referentie',
      description: 'Omschrijving',
      quantity: 'Aantal',
      unitPrice: 'Eenheidsprijs',
      total: 'Totaal',
      vat: 'BTW',
      paymentInformation: 'Betaalinformatie',
      amountToPay: 'Te betalen bedrag',
      toBePaidBefore: 'Te betalen voor',
      beneficiary: 'Begunstigde',
      message: 'Mededeling',
      generalTermsAndConditions: 'Algemene verkoopsvoorwaarden in bijlage',
      questionsOrComments: 'Voor vragen contacteer de boekhouding op {{email}}',
    },
    quotation: {
      quotation: 'Offerte',
      customerNumber: 'Klantnummer',
      reference: 'Referentie',
      date: 'Offertedatum',
      dueDate: 'Vervaldatum',
      from: 'Van',
      to: 'Naar',
      volume: 'Volume',
      price: 'Prijs',
      generalTermsAndConditions: 'Algemene verkoopsvoorwaarden in bijlage',
      questionsOrComments: 'Voor vragen contacteer ons op {{email}}',
      trailerTypes: 'Trailer types',
    },
    sustainabilityReport: {
      sustainabilityReport: 'Duurzaamheidsrapport',
      date: 'Datum',
      ourReference: 'Onze referentie',
      yourReference: 'Uw referentie',
      truck: 'Vrachtwagen',
      distance: 'Afstand',
      weight: 'Gewicht',
      emissions: 'Emissies',
      questionsOrComments: 'Vragen of opmerkingen?',
      contactFileManager: 'Neem gerust contact op met uw dossierverantwoordelijke',
      phone: 'Tel.',
      email: 'E-mail',
    },
    globalSustainabilityReport: {
      sustainabilityReport: 'Duurzaamheidsrapport',
      date: 'Datum',
      startDate: 'Start datum',
      endDate: 'Eind datum',
      orderCount: 'Aantal Orders',
      truck: 'Vrachtwagen',
      totals: 'Totaal',
      distance: 'Afstand',
      weight: 'Gewicht',
      emissions: 'CO2 emissies',
      averagePerOrder: 'Gemiddelde per order',
      framework: 'Voor details over de berekening van de emissies, bekijk het duurzaamheidsbeleid op onze website.',
      questionsOrComments: 'Vragen of opmerkingen?',
      contactFileManager: 'Neem gerust contact op met uw dossierverantwoordelijke',
      phone: 'Tel.',
      email: 'E-mail',
    },
    rideOverview: {
      title: 'Overzicht',
      entryNumber: 'Overzichtsreferentie',
      dossier: 'Dossier',
      draftBanner: 'Concept — nog niet goedgekeurd',
      invoiceRequestNotice:
        'Dit document is geen geldige self-billing factuur. Na ontvangst van dit overzicht verwacht {{customer}} van u een factuur voor deze orders.',
    },
    selfBill: {
      title: 'Self-billing factuur',
      number: 'Nr.',
      draftBanner: 'Concept — nog niet goedgekeurd',
      supplierLabel: 'Leverancier — vervoerder · wij betalen dit bedrijf',
      customerLabel: 'Klant — maakt deze factuur op in naam van de leverancier',
      vatCompanyNumber: 'Btw / ondernemingsnr.:',
      vatShort: 'btw',
      carrierNumber: 'Vervoerdersnummer: {{number}}',
      customerRegister: 'RPR Gent, afdeling Kortrijk',
      bankLabel: 'Betaling op de bankrekening van de leverancier',
      bankNotice:
        'Geregistreerd in ons vervoerdersbestand. Is dit niet uw rekening, neem dan meteen contact op met {{email}}. Bankgegevens wijzigen enkel via onze verificatieprocedure, nooit op basis van een e-mail.',
      documentType: 'Documenttype',
      invoiceNumber: 'Factuurnummer',
      invoiceDate: 'Factuurdatum',
      servicePeriod: 'Prestatieperiode',
      agreement: 'Overeenkomst',
      paymentDate: 'Betaaldatum',
      natureOfServices:
        'Aard van de diensten: {{nature}}, één rit per lijn, uitgevoerd op de vermelde verzenddatum. Eenheidsprijs = lijnbedrag (hoeveelheid 1), exclusief btw.',
      roadFreightTransport: 'goederenvervoer over de weg',
      columnNumber: 'Nr.',
      columnFile: 'Dossier',
      columnShipmentDate: 'Verzenddatum',
      columnLoading: 'Laden',
      columnUnloading: 'Lossen',
      columnQuantity: 'Aant.',
      columnVat: 'Btw',
      columnAmount: 'EUR',
      tripCountOne: '1 rit op deze factuur',
      tripCountOther: '{{count}} ritten op deze factuur',
      totalServices: 'Totaal transportdiensten (excl. btw)',
      earlyPaymentDiscount: 'Korting voor snelle betaling {{percentage}}',
      earlyPaymentCondition:
        'Bij betaling binnen 7 dagen wordt een korting van {{percentage}} ({{amount}}) in mindering gebracht. Te betalen: {{withDiscount}}. Na deze termijn: {{withoutDiscount}}.',
      taxableAmount: 'Maatstaf van heffing aan {{rate}}',
      vat: 'Btw {{rate}}',
      totalToPay: 'Totaal te betalen',
      paymentNotice:
        '{{amount}} wordt automatisch overgeschreven op {{date}} naar {{iban}}. U hoeft zelf niets te doen.',
      paymentNoticeWithoutAccount:
        '{{amount}} wordt automatisch overgeschreven op {{date}}. U hoeft zelf niets te doen.',
      yourInvoiceTitle: 'Dit is uw factuur. Stuur ons geen factuur voor deze ritten.',
      yourInvoice:
        'Dit document wordt opgemaakt door {{customer}} in naam en voor rekening van {{supplier}}, volgens de self-billingovereenkomst tussen beide partijen. Het is geen voorstel. Een factuur die u zelf stuurt voor dezelfde ritten, wordt als dubbel geweigerd.',
      acceptanceTitle: 'Aanvaarding',
      acceptance:
        'Deze factuur geldt als aanvaard door de leverancier, tenzij ze binnen 7 dagen na de factuurdatum schriftelijk betwist wordt via {{email}}. Correcties gebeuren met een self-billing creditnota.',
      paymentTermTitle: 'Betalingstermijn',
      paymentTerm:
        'De betalingstermijn is die uit uw contract. Werd er korting toegekend, dan is de betalingstermijn 7 dagen.',
      missingTripTitle: 'Ontbreekt er een rit?',
      missingTrip:
        'Een rit staat niet op deze factuur omdat de documenten niet in orde zijn. Laad de juiste documenten op in het carrierportaal en de rit komt op uw volgende self-billing factuur.',
      questionsTitle: 'Vragen?',
      questions: 'Mail naar {{email}} en vermeld het factuurnummer.',
      legalSelfBilling: 'Self-billing',
      legalNotice:
        '{{selfBilling}} — factuur uitgereikt door de afnemer in naam en voor rekening van de leverancier (art. 224 en 226 (10a) Richtlijn 2006/112/EG) · Self-billingovereenkomst {{agreement}} · Peppol BIS Self-Billing 3.0, documenttype 389',
      legalTerms:
        'Algemene verkoopsvoorwaarden in bijlage en beschikbaar op {{website}} · Belgisch recht is van toepassing · Rechtbanken van Kortrijk',
      pageFooter: '{{title}} {{number}} · {{company}}',
      page: 'Pagina {{page}} van {{total}}',
    },
    creditNote: {
      creditNote: 'Creditnota',
      customerNumber: 'Klantnummer',
      creditNoteNumber: 'Creditnota nummer',
      date: 'Datum',
      dueDate: 'Vervaldatum',
      load: 'Laden',
      unload: 'Lossen',
      ourReference: 'Onze referentie',
      yourReference: 'Uw referentie',
      description: 'Omschrijving',
      quantity: 'Aantal',
      unitPrice: 'Eenheidsprijs',
      total: 'Totaal',
      vat: 'BTW',
      paymentInformation: 'Betaalinformatie',
      amountToPay: 'Te crediteren bedrag',
      toBePaidBefore: 'Wordt gecrediteerd voor',
      payer: 'Opdrachtgever',
      message: 'Mededeling',
      generalTermsAndConditions: 'Algemene verkoopsvoorwaarden in bijlage',
      questionsOrComments: 'Voor vragen contacteer de boekhouding op {{email}}',
    },
    carrierTruckReport: {
      title: 'Truck performantierapport',
      truckname: 'Naam',
      totalIncome: 'Totaal inkomen',
      totalKm: 'Totaal kilometers',
    },
    totals: {
      totalExclVat: 'Totaal excl. BTW',
      totalVat: 'Totaal BTW',
      totalInclVat: 'Totaal incl. BTW',
      cashDiscount: 'Korting voor contant',
      netAmountToPay: 'Netto te betalen',
      vatReverseCharged: 'BTW verlegd, artikel 44 BTW richtlijn',
    },
  },
  carrierTerms: {
    agreement: 'Ik ga akkoord met de {{terms}}, inclusief de self-billing procedure.',
    termsLink: 'algemene voorwaarden',
  },
  pages: {
    confirmOrderStates: {
      headingRefused: 'Order is geweigerd',
      headingCancelled: 'Order is geannuleerd',
      headingConfirmed: 'Order is bevestigd',
      headingUnknownStatus: 'Order is al uitgevoerd of status onbekend',
    },
    confirmOrderPlanningStates: {
      headingRefused: 'Planning is geweigerd',
      headingCancelled: 'Planning is geannuleerd',
      headingConfirmed: 'Planning is bevestigd',
      headingUnknownStatus: 'Planning is al uitgevoerd of status onbekend',
    },
    confirmOrder: {
      heading: 'Bevestig transport order {{order.orderNumber}}',
      orderConfirmed: 'Order bevestigd',
      orderConfirmationError: 'Kon order niet bevestigen: {{error}}',
      confirmButton: 'Bevestig transport order',
    },
    confirmPlanning: {
      heading: 'Bevestig planning {{planningDate}}',
      planningConfirmed: 'Planning bevestigd',
      confirmButton: `Bevestig planning`,
    },
    refuseOrder: {
      heading: 'Weiger transport order {{order.orderNumber}}',
      orderRefused: 'Order geweigerd',
      orderRefusalError: 'Kon order niet weigeren: {{error}}',
      refuseButton: 'Weiger transport order',
    },
    refusePlanning: {
      heading: 'Weiger planning {{planningDate}}',
      planningRefused: 'Planning geweigerd',
      refuseButton: 'Weiger planning',
    },
    orderSummary: {
      loadAndUnloadInformation: 'Laad- en los informatie',
      load: 'Laden',
      unload: 'Lossen',
      freightRate: 'Vrachttarief',
      total: 'Totaal',
    },
  },
  portal: {
    requestAccount: {
      requestCustomerAccount: 'Vraag een account aan als opdrachtgever',
      requestCarrierAccount: 'Vraag een account aan als vervoerder',
      success: 'Aanvraag is verzonden, we zullen u contacteren voor verdere stappen.',
      failed: 'Kon account niet aanvragen: {{error}}',
      name: 'Naam',
      email: 'Email',
      companyName: 'Bedrijfsnaam',
      companyNumber: 'Ondernemingsnummer',
      request: 'Vraag aan',
      dontHaveAnAccount: 'Heeft u nog geen account?',
      accountRequestFailed: 'Accountaanvraag mislukt',
    },
  },
  customerPortal: {
    switch: 'Verander Klant',
    selectCustomer: 'Selecteer klant',
    requestAccount: {
      title: 'Vraag een account aan',
      success: 'Aanvraag is verzonden, we zullen u contacteren voor verdere stappen.',
      failed: 'Kon account niet aanvragen: {{error}}',
      name: 'Naam',
      email: 'Email',
      companyName: 'Bedrijfsnaam',
      companyNumber: 'Ondernemingsnummer',
      request: 'Vraag aan',
      dontHaveAnAccount: 'Heeft u nog geen account?',
    },
    invite: {
      title: 'Uitgenodigd tot klantenportaal',
      details:
        'Je bent uitgenodigd voor het klantportaal van TransDirect, maak je account aan door je wachtwoord in te voeren.',
      accepted: 'Uitnodiging is geaccepteerd, je wordt zo doorgestuurd naar de homepagina.',
      acceptError: 'Kon uitnodiging niet accepteren: {{error}}',
      acceptButtonText: 'Uitnodiging accepteren',
      password: 'Wachtwoord',
      repeatPassword: 'Herhaal wachtwoord',
    },
    home: {
      customerPortal: 'Klantenportaal',
      title: 'Klantenportaal',
      hello: 'Hallo,',
      welcome: 'Welkom bij het klantenportaal.',
      manageOrders: 'Beheer al je transport opdrachten.',
      viewInvoices: 'Bekijk en betaal facturen eenvoudig.',
      createQuotes: 'Maak en volg offertes.',
      viewLocations: 'Bekijk alle transport locaties.',
    },
    locations: {
      locations: 'Locaties',
      location: 'Locatie',
      name: 'Naam',
      street: 'Straat',
      number: 'Nr',
      countryCode: 'Landcode',
      postalCode: 'Postcode',
      city: 'Gemeente',
      country: 'Land',
      language: 'Taal',
      notes: 'Notities',
      createLocation: 'Maak locatie aan',
      newLocation: 'Nieuwe locatie',
      locationCreated: 'Locatie aangemaakt',
      couldNotCreateLocation: 'Kon locatie niet aanmaken: {{error}}',
      findLocation: 'Zoek een locatie...',
      address: 'Adres',
      locationNotFound: 'Locatie niet gevonden',
      couldNotLoadLocation: 'Kon locatie niet laden: {{error}}',
    },
    order: {
      duplicate: 'Dupliceer',
      bulkDuplicate: 'Bulk dupliceren',
      bulkDuplicateTitle: 'Bulk order dupliceren',
      bulkDuplicateDescription: 'Maak meerdere kopieën van deze order aan met oplopende factuurreferenties.',
      numberOfDuplicates: 'Aantal duplicaten',
      baseInvoiceRef: 'Start factuurreferentie',
      baseInvoiceRefHelper:
        'Numerieke basis. Voorloopnullen worden verwijderd. Referenties worden basis t/m basis+aantal-1.',
      skipDraft: 'Sla concept-status over (direct als Aangemaakt)',
      bulkDuplicateSuccess: '{{count}} orders aangemaakt',
      bulkDuplicateError: 'Kon orders niet dupliceren: {{error}}',
      referencePreview: 'Referenties: {{first}} t/m {{last}}',
      overview: 'Overzicht',
      updateInvoiceRef: 'Pas factuur referentie aan',
      updated: 'Bestelling is bijgewerkt',
      couldNotUpdate: 'Kon bestelling niet bijwerken: {{error}}',
    },
    orders: {
      orders: 'Orders',
      placeOrder: 'Plaats een order',
      invoiceRef: 'Factuur referentie',
      orderRef: 'Order referentie',
      loadLocation: 'Laadplaats',
      unloadLocation: 'Losplaats',
      loadDate: 'Laaddatum',
      loadTime: 'Laadtijd',
      unloadDate: 'Losdatum',
      unloadTime: 'Lostijd',
      invoiceTotal: 'Facturatietotaal',
      status: 'Status',
      invoiceStatus: 'Facturatiestatus',
      hasCMR: 'Heeft CMR',
      creationDate: 'Ingave datum',
      executionDate: 'Uitvoeringsdatum',
      fileManager: 'Dossier beheerder',
      cancellationReason: 'Annuleringsreden',
      stops: 'Stops',
      deleteStop: 'Verwijder stop',
      purchases: 'Aankopen',
      total: 'Totaal',
      trailerTypes: 'Trailer types',
      loadingMethod: 'Wijze van belading',
      load: 'Laden',
      unload: 'Lossen',
      typeStop: 'Type stop',
      extraNotes: 'Extra notities',
      noContent: 'Geen inhoud',
      packaging: 'Verpakking',
      coli: 'Coli',
      content: 'Inhoud',
      addContent: 'Voeg inhoud toe',
      deleteContent: 'Verwijder inhoud',
      noStops: 'Geen stops',
      noStopsError: 'Voeg minstens een laad en los stop toe',
      reference: 'Referentie',
      complaints: 'Klachten',
      fileComplaint: 'Klacht rapporteren',
      fileComplaintDescription: 'Vul dit formulier in om een klacht te rapporteren',
      send: 'Verzend',
      reason: 'Reden',
      details: 'Details',
      complaintFiled: 'Klacht verzonden',
      couldNotFileComplaint: 'Kon klacht niet verzenden: {{error}}',
      placeAnOrder: 'Plaats een order',
      assignment: 'Opdracht',
      addStop: 'Voeg stop toe',
      location: 'Locatie',
      date: 'Datum',
      start: 'Start',
      stop: 'Stop',
      weight: 'Gewicht (kg)',
      volume: 'Volume (m3)',
      loadMeter: 'Laadmeter',
      stopsRequired: 'Minstens 1 stop is vereist',
      contentRequired: 'Minstens 1 inhoudsitem is vereist',
      truck: 'Truck',
      distance: 'Afstand',
      emissions: 'Emissies',
      sustainability: 'Duurzaamheid',
      attachments: 'Bijlagen',
      uploadAttachments: 'Upload bijlagen',
      attachmentDeleted: 'Bijlage verwijderd',
      couldNotDeleteAttachment: 'Kon bijlage niet verwijderen: {{error}}',
      uploadedAttachment: 'Bijlage {{document}} geüpload',
      uploadFailed: 'Bijlage {{document}} kon niet worden opgeladen: {{error}}',
      route: 'Route',
      chooseMethod: 'Kies een methode',
      automatic: 'Automatisch',
      automaticDescription:
        'Upload een of meerdere transport order PDFs en onze AI haalt de ordergegevens automatisch op. Elk PDF wordt een apart order.',
      manual: 'Handmatig',
      manualDescription: 'Vul het orderformulier zelf in met alle stops, lading en leveringsgegevens.',
      uploadPdfs: 'Upload transport order PDFs',
      processingPdf: 'PDF verwerken...',
      createOrders: 'Orders aanmaken',
      orderCreated: 'Order aangemaakt',
      ordersCreated: '{{count}} orders aangemaakt',
      couldNotCreateFromPdf: 'Kon order niet aanmaken van PDF: {{error}}',
      uploadAtLeastOnePdf: 'Upload minstens een PDF',
      viewOrder: 'Bekijk order',
      creatingOrders: 'Orders aanmaken...',
      report: 'Rapport',
      orderPlaced: 'Order geplaatst',
      couldNotPlaceOrder: 'Kon order niet plaatsen: {{error}}',
      stopNumber: 'Stop {{number}} - {{type}}',
      orderLink: 'Order {{orderNumber}} - {{customerRef}}',
    },
    quotes: {
      quotes: 'Offertes',
      quote: 'Offerte',
      quoteReference: 'Offerte referentie',
      quoteDate: 'Offerte datum',
      expirationDate: 'Vervaldatum',
      total: 'Totaal',
      search: 'Zoek een offerte...',
      quotation: 'Offerte {{reference}}',
      notFound: 'Offerte niet gevonden',
      departurePlace: 'Vertrekplaats',
      destination: 'Bestemming',
      distance: 'Afstand',
      price: 'Prijs',
      type: 'Offerte Type',
      requests: 'Offerte aanvragen',
      request: 'Vraag offerte aan',
      notes: 'Notities',
      lines: 'Offerte lijnen',
      addLine: 'Voeg lijn toe',
      noLines: 'Geen offerte lijnen',
      requestTitle: 'Offerte aanvraag {{reference}}',
      requestSuccess: 'Offerte aangevraagd',
      requestFailed: 'Kon offerte niet aanvragen: {{error}}',
      quotationRequests: 'Offerte aanvragen',
      requestedAt: 'Aangevraagd op',
      hasQuote: 'Heeft offerte',
      generalInformation: 'Algemene informatie',
      removeLine: 'Verwijder lijn',
    },
    quoteLine: {
      from: 'Van',
      to: 'Naar',
    },
    invoices: {
      invoices: 'Facturen',
      invoiceNumber: 'Factuurnummer',
      invoiceDate: 'Factuurdatum',
      dueDate: 'Vervaldatum',
      total: 'Totaal',
      search: 'Zoek een factuur...',
      notFound: 'Factuur niet gevonden',
      invoice: 'Factuur {{invoiceNumber}}',
      structuredComment: 'Gestructureerde mededeling',
      reference: 'Referentie',
      sentAt: 'Verzonden op',
      load: 'Laden',
      unload: 'Lossen',
      description: 'Omschrijving',
      amount: 'Aantal',
      unitPrice: 'Eenheidsprijs',
      vat: 'BTW',
      extraInformation: 'Extra informatie: {{extraInformation}}',
      orderTotal: 'Order totaal: €{{total}}',
      totalExclVat: 'Totaal excl btw:',
      totalVat: 'Totaal btw:',
      totalInclVat: 'Totaal incl btw:',
      generalInformation: 'Algemene informatie',
    },
    creditNotes: {
      creditNotes: 'Creditnotas',
      creditNoteNumber: 'Creditnota nummer',
      creditNoteDate: 'Creditnota datum',
      dueDate: 'Vervaldatum',
      total: 'Totaal',
      search: 'Zoek een credit nota...',
      notFound: 'Creditnota niet gevonden',
      creditNote: 'Creditnota {{creditNoteNumber}}',
      structuredComment: 'Gestructureerde mededeling',
      reference: 'Referentie',
      sentAt: 'Verzonden op',
      load: 'Laden',
      unload: 'Lossen',
      description: 'Omschrijving',
      amount: 'Aantal',
      unitPrice: 'Eenheidsprijs',
      vat: 'BTW',
      extraInformation: 'Extra informatie: {{extraInformation}}',
      orderTotal: 'Order totaal: €{{total}}',
      totalExclVat: 'Totaal excl btw:',
      totalVat: 'Totaal btw:',
      totalInclVat: 'Totaal incl btw:',
      generalInformation: 'Algemene informatie',
    },
    businessInformation: {
      businessInformation: 'Bedrijfsgegevens',
      updateBusinessInformation: 'Werk bedrijfsgegevens bij',
      name: 'Naam',
      vatNumber: 'BTW-nummer',
      businessNumber: 'Ondernemingsnummer',
      saveChanges: 'Wijzigingen opslaan',
      informationChanged: 'Informatie is bijgewerkt',
      informationNotChanged: 'Kon informatie niet bijwerken: {{error}}',
      requestChanges: 'Om bedrijfsnummer, btw nummer of naam van bedrijf aan te passen, gelieve ons te contacteren',
    },
    ourInformation: {
      ourInformation: 'Bedrijfsgegevens TransDirect',
      name: 'Naam',
      vatNumber: 'BTW-nummer',
      businessNumber: 'Ondernemingsnummer',
      address: 'Adres',
      contact: 'Contact',
      phoneNumber: 'Telefoonnummer',
      emailTransport: 'Email transport',
      emailAccounting: 'Email boekhouding',
      emailGeneral: 'Email algemeen',
    },
    contacts: {
      contacts: 'Contacten',
      name: 'Naam',
      email: 'Email',
      phone: 'Telefoon',
      function: 'Functie',
      language: 'Taal',
      notifications: 'Contact geschikt voor',
      newContact: 'Nieuw contact',
      contactCreated: 'Contact aangemaakt',
      couldNotCreateContact: 'Kon contact niet aanmaken: {{error}}',
      createContact: 'Maak contact aan',
      notFound: 'Contact niet gevonden',
      updatedContact: 'Contact bijgewerkt',
      couldNotUpdateContact: 'Kon contact niet bijwerken: {{error}}',
      updateContact: 'Werk contact bij',
      delete: 'Verwijder',
      deleteContact: 'Verwijder contact',
      deleteContactConfirmation: 'Ben je zeker dat je contact {{name}} wilt wissen?',
      deleteContactError: 'Kon contact niet verwijderen: {{error}}',
      deleteContactSuccess: 'Contact verwijderd',
    },
    users: {
      users: 'Gebruikers',
      inviteUser: 'Nodig gebruiker uit',
      invitedUsers: 'Uitgenodigde gebruikers',
      noInvitedUsers: 'Geen uitgenodigde gebruikers',
      removeInvite: 'Verwijder uitnodiging',
      confirmRemoveInvite: 'Ben je zeker dat je de uitnodiging voor {{email}} wilt verwijderen?',
      inviteRemoved: 'Uitnodiging verwijderd',
      couldNotRemoveInvite: 'Kon uitnodiging niet verwijderen: {{error}}',
      noUsersFound: 'Geen gebruikers gevonden',
      removeUser: 'Verwijder gebruiker',
      confirmRemoveUser: 'Ben je zeker dat je de gebruiker {{name}} wilt verwijderen?',
      userRemoved: 'Gebruiker verwijderd',
      couldNotRemoveUser: 'Kon gebruiker niet verwijderen: {{error}}',
      active: 'Actief',
      inactive: 'Inactief',
      userInvited: 'Gebruiker uitgenodigd',
      couldNotInviteUser: 'Kon gebruiker niet uitnodigen: {{error}}',
      name: 'Naam',
      email: 'E-Mail',
      isActive: 'Is actief?',
      invited: 'Uitgenodigd',
    },
    cmrReminder: {
      cmrReminder: 'CMR Herinnering',
      sendReminder: 'Verzend',
      confirmText: 'Ben je zeker dat je een CMR herinnering wilt versturen?',
      confirmation: 'CMR Herinnering verstuurd',
      error: 'Kon cmr herinnering niet versturen: {{error}}',
    },
    sustainability: {
      sustainability: 'Duurzaamheid',
      policy: 'Duurzaamheidsbeleid',
      viewOverview: 'Bekijk het duurzaamheidsoverzicht',
      orderCount: 'Aantal orders',
      totalDistance: 'Totale afstand',
      totalWeight: 'Totaal gewicht',
      totalEmissions: 'Totale CO2-uitstoot',
      averageDistance: 'Gemiddelde afstand',
      averageWeight: 'Gemiddeld gewicht',
      averageEmissions: 'Gemiddelde CO2 uitstoot',
      total: 'Totaal',
      avgPerOrder: 'Gemiddeld per order',
    },
    settings: {
      settings: 'Instellingen',
    },
    apiKeys: {
      apiKeys: 'API Sleutels',
      createApiKey: 'API Sleutel aanmaken',
      name: 'Naam',
      scopes: 'Rechten',
      status: 'Status',
      lastUsed: 'Laatst gebruikt',
      createdAt: 'Aangemaakt op',
      prefix: 'Prefix',
      active: 'Actief',
      revoked: 'Ingetrokken',
      expired: 'Verlopen',
      never: 'Nooit',
      revokeApiKey: 'API Sleutel intrekken',
      confirmRevoke:
        'Weet je zeker dat je API sleutel "{{name}}" wilt intrekken? Dit kan niet ongedaan worden gemaakt.',
      apiKeyRevoked: 'API sleutel is ingetrokken',
      couldNotRevoke: 'Kon API sleutel niet intrekken: {{error}}',
      apiKeyCreated: 'API sleutel is aangemaakt',
      couldNotCreate: 'Kon API sleutel niet aanmaken: {{error}}',
      copyKey: 'Kopieer sleutel',
      keyCopied: 'Sleutel gekopieerd',
      keyWarning: 'Bewaar deze sleutel veilig. Deze wordt niet meer getoond.',
      noApiKeys: 'Geen API sleutels gevonden',
      ordersRead: 'Orders lezen',
      ordersWrite: 'Orders aanmaken',
      maxKeysReached: 'Maximum aantal API sleutels bereikt',
      scopeRequired: 'Minstens één scope is vereist',
    },
    loading: 'Laden...',
  },
  liveTracking: {
    title: 'Tracking',
    subtitle: 'Locatie en boordcomputer van deze trekker.',
    loading: 'Locatie ophalen…',
    noPosition: 'Nog geen locatie bekend voor deze trekker.',
    noPositionHint: 'Koppel een voertuig aan deze nummerplaat op de integratiepagina.',
    noConnection: 'Er is nog geen tracking-koppeling die deze trekker volgt. Koppel er een om de locatie te zien.',
    driving: 'Rijdt',
    idle: 'Stil',
    location: 'Locatie',
    speed: 'Snelheid',
    heading: 'Richting',
    odometer: 'Kilometerstand',
    fuel: 'Brandstof',
    lastMeasurement: 'Laatste meting',
    liveActive: 'Live tracking actief — elke 30 seconden ververst.',
    lastSignal: 'Laatste signaal',
    trailer: 'Oplegger',
    refresh: 'Ververs',
    startLive: 'Start live tracking',
    stopLive: 'Stop live tracking',
    resizePanel: 'Formaat van het zijpaneel aanpassen',
    connections: 'Tracking-koppelingen',
    connectionsSubtitle: 'Koppel de tracking-omgeving van een leverancier om hun trekkers te volgen.',
    addConnection: 'Tracking-koppeling toevoegen',
    integrations: 'Tracking-integraties',
    integrationsHint: 'Kies een provider om de tracking van een leverancier te koppelen.',
    providerFleetmaster: 'Volg de locatie en boordcomputer van trekkers via FleetMaster.lt.',
    providerSuivo: 'Volg de locatie van onze opleggers via Suivo-trackers.',
    connectionLabel: 'Naam',
    connectionLabelHelp: 'Hoe deze koppeling in de lijst komt te staan.',
    helpCompanyId: 'Het bedrijfs-id uit je FleetMaster-telematica-account.',
    helpSuivoBaseUrl: 'Laat leeg voor de standaard Suivo-omgeving.',
    ownerKindLabel: 'Eigenaar',
    ownerKindCompany: 'Eigen vloot (bedrijf)',
    ownerKindCarrier: 'Charter/leverancier',
    ownerLabel: 'Leverancier-id',
    ownerHelp: 'Voor een koppeling van een charter/leverancier.',
    supplierOwnerCompany: 'Eigen vloot',
    credentialsNote: 'De sleutel wordt versleuteld opgeslagen en is na het opslaan niet meer zichtbaar.',
    connect: 'Koppelen',
    back: 'Terug',
    noConnections: 'Nog geen tracking-koppeling.',
    noConnectionsHint: 'Voeg er een toe om de locaties van de trekkers te zien.',
    moreConnectionsTitle: 'Meer tracking-koppelingen komen binnenkort',
    moreConnectionsBody: 'We werken aan meer tracking-koppelingen — nieuwe providers verschijnen hier vanzelf.',
    connectionsLoading: 'Koppelingen ophalen…',
    vehiclesLoading: 'Voertuigen ophalen…',
    noVehicles: 'Deze koppeling meldt nog geen voertuigen.',
    statusActive: 'Actief',
    statusError: 'Fout',
    keyLabel: 'sleutel',
    linkedCount: '{{linked}} van {{total}} voertuigen gekoppeld',
    lastChecked: 'laatste controle',
    never: 'nooit',
    supplierOwner: 'Leverancier #{{id}}',
    connectionSettings: 'Koppelingsinstellingen',
    verify: 'Controleren',
    verifyOk: 'De verbinding werkt.',
    verifyFailed: 'De verbinding kon niet worden gecontroleerd.',
    remove: 'Verwijderen',
    removeTitle: 'Koppeling verwijderen',
    removeDescription: 'De koppeling "{{label}}" en de opgeslagen sleutel worden verwijderd.',
    connectionRemoved: 'Koppeling verwijderd.',
    linkVehicles: 'Voertuigen koppelen',
    linkVehiclesHint: 'Kies een voertuig en daarna de trekker waarin het rijdt.',
    link: 'Koppelen',
    unlink: 'Ontkoppelen',
    linkTruck: 'Trekker koppelen',
    chooseTruck: 'Trekker',
    chooseTruckHelp: 'Kies de trekker waarin dit voertuig rijdt.',
    chooseTruckRequired: 'Kies een trekker',
    moreTrucks: 'Alleen de eerste {{count}} trekkers worden getoond — zoek om de lijst te verfijnen.',
    plateMatch: 'nummerplaat komt overeen',
    linkedTo: 'Gekoppeld aan {{truck}}',
    linkedManually: 'handmatig',
    notLinked: 'Niet gekoppeld',
    vehicleLinked: 'Voertuig gekoppeld.',
    vehicleUnlinked: 'Koppeling verwijderd.',
    trailerSubtitle: 'Locatie van deze oplegger.',
    linkTracker: 'Koppel tracker',
    linkTrackerHint: 'Kies het voertuig dat in deze oplegger zit.',
    linkTrailer: 'Oplegger koppelen',
    linkTrailerHint: 'Kies een voertuig en daarna de oplegger waarop het zit.',
    chooseTrailer: 'Oplegger',
    chooseTrailerRequired: 'Kies een oplegger',
    noTrackerLinked: 'Er is nog geen tracker aan deze oplegger gekoppeld — koppel er een om de locatie te zien.',
    noTrailerPosition: 'Nog geen locatie bekend voor deze oplegger.',
    searchUnits: 'Zoek op naam of nummerplaat…',
    noUnits: 'Nog geen voertuigen gemeld.',
    status: {
      moving: 'Rijdt',
      parked: 'Geparkeerd',
      idling: 'Stationair',
      immobilized: 'Geblokkeerd',
      offline: 'Geen signaal',
      inOperation: 'In bedrijf',
    },
    trailersMap: {
      searchLabel: 'Zoek (TDR ID / naam / nummerplaat)',
      searchPlaceholder: 'Zoek op naam of nummerplaat...',
      trackerLabel: 'Tracker',
      trackerAll: 'Alle trailers',
      trackerTracked: 'Met tracker',
      trackerUntracked: 'Zonder tracker',
      trackerSilent: 'Geen signaal > 24u',
      tableCardTitle: 'Trailers',
      mapCardTitle: 'Kaart',
      tableTrailer: 'Trailer',
      tablePlate: 'Nummerplaat',
      tableTracker: 'Tracker',
      tableStatus: 'Status',
      tableLastSignal: 'Laatste signaal',
      tablePlace: 'Plaats',
      noTracker: 'Geen tracker',
      clearFilters: 'Wis alle filters',
      noneTrackedTitle: 'Nog geen tracker gekoppeld',
      noneTrackedDescription: 'Koppel een Suivo-unit aan een trailer om hem op de kaart te zien.',
      noneInFilter: 'Geen trailers in deze selectie',
      noConnectionsTitle: 'Nog geen tracking-koppeling',
      noConnectionsDescription: 'Voeg een koppeling toe om de locaties van onze opleggers te zien.',
      noConnectionsAction: 'Naar tracking-integraties',
      connectionErrorTitle: 'Tracking-koppeling met een fout',
    },
  },
  carrierPortal: {
    liveTracking: { liveTracking: 'Tracking' },
    selectCarrier: 'Selecteer vervoerder',
    loading: 'Laden...',
    switch: 'Verander Vervoerder',
    home: {
      carrierPortal: 'Carrierportaal',
      title: 'Carrierportaal',
      hello: 'Hallo,',
      welcome: 'Welkom bij het carrierportaal.',
      manageOrders: 'Beheer al je transport opdrachten.',
      managePlanning: 'Beheer je planning.',
      selfBilling: 'Maak en beheer je selfbilling facturen.',
      info: 'Informatie',
      infoSubtitle: 'Informatie over TransDirect & het carrierportaal',
      contact: 'Contactpersoon',
      contactSubtitle: 'Wie is uw TransDirect contactpersoon',
      FuelCard: 'Tankkaart',
      FuelCardSubtitle: 'Vraag uw gepersonaliseerde TransDirect tankkaart aan',
      saveChanges: 'Wijzigingen opslaan',
    },
    orders: {
      orders: 'Orders',
      manageOrders: 'Beheer al uw transporten & upload uw transportdocumenten',
      orderRef: 'TD-Referentie',
      loadLocation: 'Laadlocatie',
      unloadLocation: 'Loslocatie',
      invoiceTotal: 'Vrachttarrief',
      hasCMR: 'Heeft documenten',
      documents: 'Documenten',
      cmrRejected: 'Geweigerd',
      cmrPending: 'In behandeling',
      cmrUploadHint: 'U kunt één of meerdere PDF-bestanden uploaden; wij bundelen deze tot één document.',
      cmrUploaded: 'Document opgeladen',
      cmrUploadFailed: 'Document kon niet worden opgeladen: {{error}}',
      documentValidation: 'Documenten',
      documentValidationNoDocuments: 'Geen documenten',
      documentValidationPending: 'In behandeling',
      documentValidationApproved: 'Goedgekeurd',
      documentValidationRejected: 'Afgekeurd',
      outstandingDocsTitle: 'Nog te bezorgen documenten',
      requiredDocMissing: 'ontbreekt',
      requiredDocInReview: 'in behandeling',
      requiredDocRejected: 'afgekeurd — gelieve opnieuw te uploaden',
      requiredDocStatusReceived: 'Ontvangen',
      requiredDocStatusInReview: 'In behandeling',
      requiredDocStatusRejected: 'Afgekeurd',
      requiredDocStatusMissing: 'Ontbreekt',
      requiredDocsTitle: 'Verplichte documenten',
      requiredDocsSubtitle: 'Deze klant vraagt onderstaande documenten voor deze opdracht.',
      requiredDocsProgress: '{{done}} van {{total}} ontvangen',
      requiredDocReupload: 'Opnieuw uploaden',
      uploadDocumentTitle: '{{document}} uploaden',
      uploadRequiredDoc: 'Uploaden',
      uploadDocumentsTitle: 'Documenten uploaden',
      uploadDocumentsHint:
        'Upload één of meerdere bestanden tegelijk; wij splitsen ze en koppelen elk deel aan het juiste documenttype.',
      docReasonInReview: 'in verwerking',
      docReasonRejected: 'afgekeurd',
      docRejectionLowQuality: 'onleesbaar',
      docRejectionMissingSignature: 'handtekening ontbreekt',
      docRejectionNoOrderReference: 'geen referentie gevonden',
      docRejectionNotNeutral: 'niet-neutrale CMR',
      docRejectionWrongCustomer: 'verkeerde klant',
      docRejectionWrongDeliveryAddress: 'verkeerd leveradres',
      docRejectionWrongDocumentType: 'verkeerd documenttype',
      docRejectionWrongOrgOnDocument: 'verkeerde organisatie',
      requiredDocUploaded: 'Document opgeladen',
      requiredDocUploadFailed: 'Document kon niet worden opgeladen: {{error}}',
      purchases: 'Vrachttarief',
      allAccepted: 'Alle orders bevestigd',
      customerReference: 'Klantreferentie',
      draft: 'Concept',
      load: 'Laden',
      unload: 'Lossen',
      reference: 'Referentie',
      assignee: 'Toegewezen aan',
      orderAssigned: 'Order toegewezen',
      changeAssignee: 'Wijzigen',
      assignOrder: 'Order toewijzen',
      assign: 'Toewijzen',
      route: 'Route',
      error: 'Fout',
      report: 'Rapport',
    },
    planning: {
      planning: 'Planning',
      managePlanning: 'Bekijk en beheer uw transportplanning',
      acceptAll: 'Alles accepteren',
      actions: 'Acties',
      date: 'Datum',
      loadingOrders: 'Orders aan het laden...',
      noTruck: 'Deze vervoerder heeft nog geen truck.',
      ordersForTruck: 'Orders voor truck met nummerplaat {{licensePlate}}',
      truck: 'Truck',
    },
    selfBilling: {
      selfBilling: 'Self Billing',
      rideOverview: 'Ritoverzicht',
      manageRideOverview: 'Bekijk en download uw ritoverzichten',
      searchRideOverviewPlaceholder: 'Zoek een ritoverzicht...',
      type: 'Type',
      number: 'Nummer',
      manageSelfBilling: 'Bekijk en download uw Self Billing',
      searchPlaceholder: 'Zoek een self billing...',
      id: 'Interne ref',
      date: 'Datum',
      download: 'Download',
      invoice: 'Factuur',
      title: 'Self Billing Invoice',
    },
    businessInformation: {
      businessInformation: 'Bedrijfsgegevens',
      settingsAndBusinessInformation: 'Instellingen en bedrijfsgegevens',
      tabGeneral: 'Algemeen',
      tabFleet: 'Wagenpark',
      tabContacts: 'Contacten',
      civilLiabilityInsurance: 'BA Verzekering',
      CMRInsurance: 'CMR Verzekering',
      transportationInsurance: 'Transport Verzekering',
      documentUploaded: 'Document opgeladen',
      insurances: 'Verzekeringen',
    },
    generalInformation: {
      generalInformation: 'Informatie',
      noDocumentsAvailable: 'Geen documenten beschikbaar',
      checkBackLater: 'Kom later terug voor bijgewerkte documentatie',
    },

    contacts: {
      contacts: 'Contacten',
      newContact: 'Nieuw contact',
      updateContact: 'Bewaar contact',
      name: 'Naam',
      email: 'E-mail',
      phone: 'Telefoon',
      function: 'Functie',
      language: 'Taal',
      delete: 'Verwijderen',
      createContactSuccess: 'Contact succesvol aangemaakt',
      createContactError: 'Fout bij het aanmaken van contact: {{error}}',
      updateContactSuccess: 'Contact succesvol bijgewerkt',
      updateContactError: 'Fout bij het bijwerken van contact: {{error}}',
      deleteContact: 'Contact Verwijderen',
      deleteContactConfirmation: 'Weet u zeker dat u uw contact wilt verwijderen?',
      deleteContactSuccess: 'Contact succesvol verwijderd',
      deleteContactError: 'Fout bij het verwijderen van contact: {{error}}',
      notFound: 'Contact niet gevonden',
      notifications: 'Notificaties',
    },
    trucks: {
      title: 'Trekkers',
      newTruck: 'Nieuwe trekker',
      update: 'Trekker updaten',
      licensePlate: 'Nummerplaat',
      codeName: 'Codenaam',
      planner: 'Planner',
      isActive: 'Actief',
      insuranceExpiresAt: 'Verzekering vervalt op',
      examinationExpiresAt: 'Keuring vervalt op',
      documents: 'Documenten',
      yes: 'Ja',
      no: 'Nee',
      moveUp: 'Omhoog',
      moveDown: 'Omlaag',
      create: 'Aanmaken',
      succeeded: 'Trekker opgeslaan',
      createError: 'Kon trekker niet aanmaken: ',
      updateError: 'Kon trekker niet updaten: ',
      insurance: 'Verzekering',
      insuranceUploaded: 'Verzekering opgeslagen',
      examination: 'Keuring',
      examinationUploaded: 'Keuring opgeslagen',
      notFound: 'Geen trucks gevonden',
      appLoginTitle: 'Chauffeur-app login',
      appLoginHint:
        'Chauffeurs loggen in met de nummerplaat. Stel hier het wachtwoord in; chauffeurs kunnen hun wachtwoord niet zelf resetten.',
      appPasswordLabel: 'Wachtwoord chauffeur-app',
      appLoginLabel: 'Login (nummerplaat)',
      appCodeNameLabel: 'Codenaam',
      appSavePassword: 'Wachtwoord opslaan',
      appDisableLogin: 'Login uitschakelen',
      appPasswordSaved: 'Wachtwoord opgeslagen',
      appLoginDisabled: 'Chauffeur-app login uitgeschakeld',
      detailsTitle: 'Trekkergegevens',
      documentCount: '{{count}} van {{total}}',
      statusValid: 'Geldig',
      statusExpiringSoon: 'Verloopt binnenkort',
      statusExpired: 'Verlopen',
      statusMissing: 'Ontbreekt',
      expiresOn: 'Vervalt {{date}}',
      noDocument: 'Nog geen document opgeladen',
      viewDocument: 'Bekijken',
      replaceDocument: 'Vervangen',
      uploadDocument: 'Opladen',
      searchPlaceholder: 'Zoek op nummerplaat…',
      noExpiryKnown: 'Geen vervaldatum bekend',
      notUploadedYet: 'Nog niet geüpload',
    },
    trailers: {
      title: 'Trailers',
      truckAmount: 'Aantal trekkers',
      tautlinerAmount: 'Aantal tautliners',
      boxTrailerAmount: 'Aantal box/frigo trailers',
      openTrailerAmount: 'Aantal open trailers',
      save: 'Aanpassingen opslaan',
      saveSuccess: 'Vervoerder aangepast',
      saveError: 'Kon vervoerder niet aanpassen: {{error}}',
      subtitle: 'Aantallen per type — gebruikt voor capaciteitsplanning',
    },
    driverBlock: {
      title: 'Chauffeur toegang',
      message: 'Log in op de chauffeur app op je mobiel om je orders te bekijken.',
    },
    notFound: {
      pageNotFound: 'Pagina niet gevonden.',
      pageNotFoundDesc:
        'Deze pagina lijkt (nog) niet te bestaan. Als u denkt dat er iets niet klopt, neem dan contact op met uw TransDirect contactpersoon.',
    },
    invite: {
      title: 'Uitgenodigd tot Carrier Portaal',
      details:
        'Je bent uitgenodigd voor het carrier portaal van TransDirect, maak je account aan door je wachtwoord in te voeren.',
      accepted: 'Uitnodiging is geaccepteerd, je wordt zo doorgestuurd naar de homepagina.',
      acceptError: 'Kon uitnodiging niet accepteren: {{error}}',
      acceptButtonText: 'Uitnodiging accepteren',
      password: 'Wachtwoord',
      repeatPassword: 'Herhaal wachtwoord',
    },
    users: {
      users: 'Gebruikers',
      inviteUser: 'Nodig gebruiker uit',
      invitedUsers: 'Uitgenodigde gebruikers',
      noInvitedUsers: 'Geen uitgenodigde gebruikers',
      removeInvite: 'Verwijder uitnodiging',
      confirmRemoveInvite: 'Ben je zeker dat je de uitnodiging voor {{email}} wilt verwijderen?',
      inviteRemoved: 'Uitnodiging verwijderd',
      couldNotRemoveInvite: 'Kon uitnodiging niet verwijderen: {{error}}',
      noUsersFound: 'Geen gebruikers gevonden',
      removeUser: 'Verwijder gebruiker',
      confirmRemoveUser: 'Ben je zeker dat je de gebruiker {{name}} wilt verwijderen?',
      userRemoved: 'Gebruiker verwijderd',
      couldNotRemoveUser: 'Kon gebruiker niet verwijderen: {{error}}',
      active: 'Actief',
      inactive: 'Inactief',
      userInvited: 'Gebruiker uitgenodigd',
      couldNotInviteUser: 'Kon gebruiker niet uitnodigen: {{error}}',
      name: 'Naam',
      email: 'E-Mail',
      isActive: 'Is actief?',
      role: 'Rol',
      roleDispatcher: 'Dispatcher',
      roleDriver: 'Chauffeur',
      activeUsers: 'Actieve gebruikers',
      pendingInvitations: 'Openstaande uitnodigingen',
      sendInvitation: 'Verstuur uitnodiging',
      sending: 'Verzenden...',
      cancel: 'Annuleren',
      emailAddress: 'E-mailadres',
      deleteInvitation: 'Verwijder uitnodiging',
      joined: 'Lid sinds',
      invited: 'Uitgenodigd',
      assignee: 'Toegewezen aan',
      assignOrder: 'Order toewijzen',
      unassigned: 'Niet toegewezen',
      assignedTo: 'Toegewezen aan',
      roleUpdated: 'Rol bijgewerkt',
      renameUser: 'Gebruiker hernoemen',
      newName: 'Nieuwe naam',
      userRenamed: 'Gebruiker hernoemd',
      save: 'Opslaan',
      permissions: 'Rechten',
      canRenameUsers: 'Kan gebruikers hernoemen',
      permissionsUpdated: 'Rechten bijgewerkt',
      nameOptional: 'Naam (optioneel)',
      emailRequired: 'Voer een e-mailadres in',
      namePlaceholder: 'Jan Janssen',
      emailPlaceholder: 'gebruiker@voorbeeld.com',
    },
    tracking: {
      loading: 'Tracking gebeurtenissen laden...',
      events: 'Tracking Events',
      noEvents: 'Geen tracking events gevonden',
      scheduled: 'Gepland',
      eventTypes: {
        StatusLoaded: 'Geladen',
        StatusUnloaded: 'Gelost',
        LocationPing: 'Locatie update',
      },
      stop: 'Stop',
      by: 'door',
    },
  },
  carrierContactNotifications: {
    transportOrders: 'Transportopdrachten',
    selfBillings: 'Self Billings',
  },
  orderStatus: {
    Draft: 'In Opmaak',
    Created: 'Aangemaakt',
    Prepayment: 'Vooruitbetaling',
    Placed: 'Geplaatst',
    Confirmed: 'Bevestigd',
    Refused: 'Geweigerd',
    Executed: 'Uitgevoerd',
    Cancelled: 'Geannuleerd',
  },
  orderSaleStatus: {
    Created: 'Aangemaakt',
    Credited: 'Gecrediteerd',
    Incomplete: 'Onvolledig',
    Invoiced: 'Gefactureerd',
  },
  customerContactNotifications: {
    invoice: 'Facturatie',
    orderConfirmation: 'Orderbevestiging',
    cmr: 'CMR',
    quotation: 'Offerte',
    dieselSurcharge: 'Diesel toeslag',
    paymentReminder: 'Betaalherinnering',
  },
  errors: {
    required: 'Vereist',
    invalidEmail: 'Ongeldig e-mailadres',
    dateShouldBeInTheFuture: 'Datum moet in de toekomst liggen',
    startTimeShouldBeBeforeEndTime: 'Starttijd moet voor eindtijd liggen',
    passwordsDontMatch: 'Wachtwoord en herhaal wachtwoord zijn niet gelijk.',
    passwordTooShort: 'Wachtwoord is te kort.',
    formValidation: 'Controleer de gemarkeerde velden in het formulier',
    retry: 'Probeer opnieuw',
    reloadPage: 'Pagina herladen',
    networkTitle: 'Verbindingsprobleem',
    networkDescription: 'We kunnen de server niet bereiken. Controleer je internetverbinding en probeer opnieuw.',
    serverTitle: 'Serverfout',
    serverDescription: 'De server kon je verzoek niet verwerken. Probeer het later opnieuw.',
    notFoundTitle: 'Niet gevonden',
    notFoundDescription: 'De gevraagde gegevens bestaan niet meer of zijn niet beschikbaar.',
    sessionTitle: 'Sessie verlopen',
    sessionDescription: 'Je sessie is verlopen of je bent niet ingelogd. Log opnieuw in om verder te gaan.',
    permissionTitle: 'Geen toegang',
    permissionDescription: 'Je hebt geen toegang tot deze gegevens.',
    validationTitle: 'Ongeldige gegevens',
    validationDescription: 'Controleer de ingevulde gegevens en probeer opnieuw.',
    rateLimitTitle: 'Te veel verzoeken',
    rateLimitDescription: 'Er zijn te veel verzoeken verstuurd. Wacht even en probeer opnieuw.',
    abortedTitle: 'Verzoek geannuleerd',
    abortedDescription: 'Het verzoek werd geannuleerd. Probeer opnieuw indien nodig.',
    unknownTitle: 'Onbekende fout',
    unknownDescription:
      'Er is een onverwachte fout opgetreden. Probeer opnieuw of contacteer support als dit blijft gebeuren.',
    loadingTitle: 'Laden mislukt',
    loadingDescription: 'De gegevens konden niet worden geladen.',
  },
  orderComplaintType: {
    Aggression: 'Fysieke/verbale agressie',
    DamagedGoods: 'Beschadigde goederen',
    IncorrectDelivery: 'Foutieve levering',
    IncorrectInvoice: 'Foutieve factuur',
    LateDelivery: 'Laattijdige levering',
    Other: 'Andere',
  },
  myProfile: {
    myProfile: 'Mijn profiel',
    logout: 'Log uit',
    name: 'Naam',
    role: 'Rol',
    email: 'Email',
    language: 'Taal',
    languageChanged: 'Taal is bijgewerkt',
    languageNotChanged: 'Kon taal niet bijwerken: {{error}}',
    joinedAt: 'Lid geworden op',
    nameChanged: 'Naam is bijgewerkt',
    nameNotChanged: 'Kon naam niet bijwerken: {{error}}',
  },
  auth: {
    forgotPassword: {
      title: 'Wachtwoord vergeten',
      requestNewPassword: 'Vraag nieuw wachtwoord aan',
      instructions:
        'Vul uw email in, als de gebruiker in het systeem bestaat zult u spoedig een email ontvangen om een nieuw wachtwoord in te stellen.',
      requestFailed: 'Kon geen nieuw wachtwoord aanvragen',
      instructionsSent: 'Instructies om een nieuw wachtwoord in te stellen zijn verzonden naar uw email adres.',
    },
    configNewPassword: {
      title: 'Stel nieuw wachtwoord in',
      newPassword: 'Nieuw wachtwoord',
      repeatNewPassword: 'Herhaal nieuw wachtwoord',
      confirmButtonText: 'Stel nieuw wachtwoord in',
      passwordDontMatch: 'Wachtwoord en herhaal wachtwoord moeten gelijk zijn',
      tokenNotFound: 'Token niet gevonden',
      invalidToken: 'Token is niet meer geldig',
      configFailed: 'Kon wachtwoord niet instellen: {{error}}',
    },
    login: {
      login: 'Login',
      email: 'Email',
      password: 'Wachtwoord',
      forgotPassword: 'Wachtwoord vergeten',
      customerLoginTitle: 'Klanten login',
      loginWithGoogle: 'Login met Google',
      incorrectCredentials: 'Email of wachtwoord is incorrect',
      loginFailed: 'Kon niet inloggen: {{error}}',
    },
    userNotFound: {
      title: 'Gebruiker niet gevonden',
      description: 'Kon niet inloggen er is een error gebeurd of gebruiker bestaat niet meer.',
      goToLoginPage: 'Ga naar login pagina',
    },
  },
  upload: {
    title: 'Upload',
    dropzoneHint: 'Klik hier of sleep bestand(en) in het vak om bestand(en) op te laden',
    uploadDocuments: 'Upload documenten',
    confirmDeleteDocument: 'Ben je zeker dat je dit document wilt verwijderen?',
    deleteDocument: 'Verwijder document',
    noDocumentsFound: 'Geen documenten gevonden',
    noDocumentsSelected: 'Geen documenten geselecteerd',
    uploadFailed: 'Kon document niet uploaden',
    uploadDocumentFailed: 'Kon bestand {{filename}} niet uploaden: {{reason}}',
    multiUploadFailed: 'Kon bestanden niet uploaden: {{reason}}',
  },
  download: {
    open: 'Openen',
    download: 'Download',
    started: 'Download gestart',
    failed: 'Download mislukt: {{message}}',
  },
  cancel: 'Annuleer',
  close: 'Sluit',
  moreInfo: 'Meer info',
  previous: 'Vorige',
  next: 'Volgende',
  delete: 'Verwijder',
  or: 'of',
  draft: 'Concept',
  save: 'Opslaan',
  chat: {
    title: 'Chat',
    sendMessage: 'Stuur bericht',
    placeholder: 'Typ een bericht...',
    noMessages: 'Nog geen berichten',
    loadMore: 'Laad meer berichten',
    messageSent: 'Bericht verzonden',
    messageError: 'Kon bericht niet verzenden: {{error}}',
    newMessage: '{{name}}: nieuw bericht op order {{orderNumber}}',
    internal: 'Intern',
    carrier: 'Transporteur',
  },
};
